import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_order_by_lookupcodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lookupcode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lookupcode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lookupcode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lookupcode: string    }) {
        if(isNil($inParams.lookupcode)) {
          return true; 
        }
      return false;
    }
}
